<template>
  <div class="gs-app gs-resources-page">
    <div class="w-full gs-resources-page__content gs-promo-areas-page">
      <v-wait for="resources">
        <create-select-funnel
          :funnels="funnels"
          :funnel="funnel"
          :selectedFunnelId="selectedFunnelId"
          @updateSelectedFunnelId="updateSelectedFunnelId"
          @openCreateResourceModal="openCreateResourceModal"
        />

        <resources-list-view
          :model="model"
          :resources="resources"
          :funnels="funnels"
          :funnel="funnel"
          @updateModel="updateModel"
          @updateResources="updateResources"
          @updateResource="updateResource"
          @openShare="openEmbedCode"
          @openCreateResourceModal="openCreateResourceModal"
        />

        <promo-area-settings-drawer
          :model="model"
          :funnel="funnel"
          :funnels="funnels"
          :resource="resource"
          :resources="resources"
          @updateResources="updateResources"
          @updateResource="updateResource"
        />

        <share-embed-drawer
          v-model="shareOpen"
          :funnel="funnel"
          :permalink="selectedPermalink"
        />
      </v-wait>
    </div>

    <portal to="headerBreadCrumb">
      <div class="cursor-pointer flex items-center -ml-4" @click="sendToFunnels">
        <chevron-left-icon class="h-3 fill-current" />
      </div>
    </portal>
  </div>
</template>

<script>
import Funnel from '@/models/Funnel';
import FunnelResource from '@/models/FunnelResource';
import axios from 'axios';
import CreateSelectFunnel from './partials/CreateSelectFunnel.vue';
import ResourcesListView from './partials/ResourcesListView.vue';
import PromoAreaSettingsDrawer from './partials/PromoAreaSettingsDrawer.vue';
import ShareEmbedDrawer from './partials/ShareEmbedDrawer.vue';
import ChevronLeftIcon from '@/assets/images/icons/ChevronLeftIcon.svg';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('funnel_promo_tools') };
  },
  components: {
    CreateSelectFunnel,
    ResourcesListView,
    PromoAreaSettingsDrawer,
    ShareEmbedDrawer,
    ChevronLeftIcon,
  },
  data() {
    return {
      funnel: null,
      funnels: [],
      selectedFunnelId: 0,
      model: this.getDefaultModel(),
      defaultLandingPages: [],
      resources: [],
      resource: null,
      selectedPermalink: '',
      shareOpen: false,
    };
  },
  computed: {
    brandName() {
      return this.$store.state.brandData.brandName;
    },
  },
  async created() {
    this.$wait.start('resources');
    this.funnel = await Funnel.$find(this.$route.params.id);

    if (
      this.funnel.main_product &&
      this.funnel.main_product.affiliate_landing_pages &&
      this.funnel.main_product.affiliate_landing_pages.length
    ) {
      this.model.landing_page_id = this.funnel.main_product.affiliate_landing_pages[0].id;
    }

    this.resources = await this.funnel.promotional_areas().$get();
    this.selectedFunnelId = this.funnel.id;
    this.funnels = await Funnel.$get();

    const { data } = await axios.get(
      `/get-default-landing-pages/${this.funnel.id}`
    );

    this.defaultLandingPages = data.landing_pages;
    this.$wait.end('resources');
  },
  methods: {
    getDefaultModel() {
      return {
        name: '',
        use_custom_video: false,
        landing_page_id: 0,
        video_link: '',
        show_more_funnels: false,
        related_funnels: [],
        show_more_resources: 0,
        related_resources: [],
        landing_pages: [],
        header_text: this.$t('frontend_groovesell_tools_affiliate_modal_branding_placeholder_text_header', {brandName: this.brandName}),
        login_text: this.$t('frontend_groovesell_tools_affiliate_modal_branding_placeholder_text_login', {brandName: this.brandName}),
        signup_text: this.$t('frontend_groovesell_tools_affiliate_modal_branding_placeholder_text_signup', {brandName: this.brandName}),
        disable_branding: false,
      };
    },
    updateSelectedFunnelId(funnelId) {
      this.selectedFunnelId = funnelId;
    },
    updateModel(model) {
      this.model = model;
    },
    updateResources(resources) {
      this.resources = resources;
    },
    updateResource(resource) {
      this.resource = resource;
    },
    openEmbedCode(resourcePermalink) {
      this.selectedPermalink = resourcePermalink;
      this.shareOpen = true;
    },
    sendToFunnels() {
      this.$router.push({ name: 'funnels' });
    },
    openCreateResourceModal() {
      this.resource = new FunnelResource({}).for(this.funnel);
      Object.assign(this.model, this.getDefaultModel());
      this.model.landing_page_id = this.funnel.main_product.affiliate_landing_pages[0].id;
      this.model.landing_pages = this.defaultLandingPages;
      this.$root.$emit('modal-open', 'create-promo-area-modal');
    },
  },
};
</script>

<style scoped>
.gs-resources-page {
  min-height: 100%;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gs-resources-page__content {
  min-width: 0;
}

.gs-promo-areas-page {
  max-width: 1260px;
  margin: 0 auto;
  padding: 32px 28px 56px;
}

@media (max-width: 1023px) {
  .gs-promo-areas-page {
    padding: 20px 16px 40px;
  }
}
</style>

<style lang="scss">
.dropdown-button-container {
  display: flex;
  align-items: center;

  .btnx {
    border-radius: 5px 0px 0px 5px;
  }

  .btn-drop {
    border-radius: 0px 5px 5px 0px;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
  }
}
</style>
